import { render, staticRenderFns } from "./AvailabilityLabel.vue?vue&type=template&id=5d0245a3&scoped=true&"
import script from "./AvailabilityLabel.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AvailabilityLabel.vue?vue&type=style&index=0&id=5d0245a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0245a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0245a3')) {
      api.createRecord('5d0245a3', component.options)
    } else {
      api.reload('5d0245a3', component.options)
    }
    module.hot.accept("./AvailabilityLabel.vue?vue&type=template&id=5d0245a3&scoped=true&", function () {
      api.rerender('5d0245a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/AvailabilityLabel.vue"
export default component.exports